import { render } from "./CandidateCommentsTab.vue?vue&type=template&id=747cf0c8&scoped=true"
import script from "./CandidateCommentsTab.vue?vue&type=script&lang=js"
export * from "./CandidateCommentsTab.vue?vue&type=script&lang=js"

import "./CandidateCommentsTab.vue?vue&type=style&index=0&id=747cf0c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747cf0c8"]])

export default __exports__